import createIcon from '../../createIcon';

/**
 * @component @name Forward5
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTRDMTggMTcuMzEgMTUuMzEgMjAgMTIgMjBDOC42OSAyMCA2IDE3LjMxIDYgMTRDNiAxMC42OSA4LjY5IDggMTIgOFYxMkwxNyA3TDEyIDJWNkM3LjU4IDYgNCA5LjU4IDQgMTRDNCAxOC40MiA3LjU4IDIyIDEyIDIyQzE2LjQyIDIyIDIwIDE4LjQyIDIwIDE0SDE4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyLjAzIDE2LjM4QzExLjU5IDE2LjM4IDExLjQ1IDE2LjA3IDExLjQzIDE1LjgySDEwLjU5QzEwLjYyIDE2LjY3IDExLjM4IDE3LjA3IDEyLjAzIDE3LjA3QzEyLjk2IDE3LjA3IDEzLjQ3IDE2LjQ0IDEzLjQ3IDE1LjY0QzEzLjQ3IDE0LjMxIDEyLjUgMTQuMiAxMi4xNyAxNC4yQzExLjk3IDE0LjIgMTEuNzQgMTQuMjUgMTEuNTMgMTQuMzZMMTEuNjQgMTMuNDRIMTMuMzRWMTIuNzNIMTAuOTVMMTAuNyAxNC45TDExLjM3IDE1LjA3QzExLjUgMTQuOTQgMTEuNjUgMTQuODQgMTEuOTQgMTQuODRDMTIuMzQgMTQuODQgMTIuNjMgMTUuMDcgMTIuNjMgMTUuNTlDMTIuNjIgMTUuNjQgMTIuNjUgMTYuMzggMTIuMDMgMTYuMzhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Forward5 = createIcon('Forward5', [
  [
    'path',
    {
      d: 'M18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14C6 10.69 8.69 8 12 8V12L17 7L12 2V6C7.58 6 4 9.58 4 14C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14H18Z',
      key: '1ldjgn',
    },
  ],
  [
    'path',
    {
      d: 'M12.03 16.38C11.59 16.38 11.45 16.07 11.43 15.82H10.59C10.62 16.67 11.38 17.07 12.03 17.07C12.96 17.07 13.47 16.44 13.47 15.64C13.47 14.31 12.5 14.2 12.17 14.2C11.97 14.2 11.74 14.25 11.53 14.36L11.64 13.44H13.34V12.73H10.95L10.7 14.9L11.37 15.07C11.5 14.94 11.65 14.84 11.94 14.84C12.34 14.84 12.63 15.07 12.63 15.59C12.62 15.64 12.65 16.38 12.03 16.38Z',
      key: 'foryc1',
    },
  ],
]);

export default Forward5;
